import React from 'react'
import '../mutualfunds/Mutual.css'
import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
// import img3 from "../../../assets/img3.jpg";
import Footer from '../../../general/footer/Footer';
import { Link } from 'react-router-dom';
import pmsimg1 from "../../../assets/pmsimg1.jpg";


const PMS = () => {
    return (
        <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">Portfolio Management Services </span>
                    </div>
                    <h1>Portfolio Management Services</h1>
                    <p>
                        At PSJ Capital Ventures, we provide access to India’s most reputed PMS providers across a wide spectrum of investment philosophies – value, growth, quant, multi-asset, thematic, and long-short strategies handpicked through rigorous research and due diligence.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={pmsimg1} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    <h2>Portfolio Management Services (PMS)</h2>
                    <p>
                        Portfolio Management Services (PMS) offer customized investment solutions to High Net-Worth Individuals (HNIs), Ultra HNIs, family offices, and institutions seeking professional management of their equity, debt, or hybrid portfolios. Unlike mutual funds, PMS accounts are tailored, offer greater flexibility, and typically follow concentrated strategies aligned to an investor’s financial goals, risk appetite, and return expectations.

                    </p>
                    {/* <h3 style={{color:'black'}}>Why Mutual Funds Matter</h3>
                    <p className="bold-line">
                        Mutual funds remain one of the most versatile and trusted investment avenues for building long-term wealth. Whether you're a first-time investor or a seasoned professional, mutual funds offer an accessible, professionally managed way to diversify across asset classes, geographies, and strategies - all within a regulated and transparent structure.<br></br>
                        <br></br>At PSJ Capital Ventures, we curate mutual fund portfolios tailored to your financial goals, risk appetite, and time horizon - backed by in-depth research and ongoing reviews.
                    </p> */}

                    <h3 style={{ color: 'black' }}>Key Terminologies</h3>
                    <div className="plan-columns">

                        <div className='key-terminologies'>
                            <h5>1. 	Corpus </h5>
                            <p>Total invested value in the PMS account.
                            </p>
                            <h5>2. 	Benchmark </h5>
                            <p>Index used to compare performance (e.g., Nifty 500, BSE 200).</p>
                        </div>
                        <div className='key-terminologies'>
                            <h5>3. 	Alpha </h5>
                            <p>Excess return generated over the benchmark.</p>
                            <h5>4. 	Drawdown </h5>
                            <p>Peak-to-trough decline in portfolio value.</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4> Why PSJ for PMS Advisory?</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 		Curated Research  </li>
                                <li>✓ 		360° Wealth Planning  </li>
                                <li>✓ 		Institutional-Grade Access  </li>
                                <li> ✓		Fee Negotiation & Transparency  </li>
                                <li> ✓  	Dedicated Relationship Manager  </li>
                            </ul>
                        </div>
                    </div>

                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>Process for Investing in PMS via PSJ Capital Ventures</h3>

                        <ul>
                            <li>✓ 	Discovery & Assessment</li>
                            <li>✓ 	Strategy Shortlisting</li>
                            <li>✓ 		Documentation & Onboarding</li>
                            <li>✓ 		Portfolio Construction</li>
                            <li>✓ 		Regular Monitoring & Reporting</li>
                            <li>✓  Exit & Taxation</li>
                        </ul>
                        <p>
                            Let’s Build Your PMS Portfolio

                            We invite you to explore how Portfolio Management Services can complement your core investments and help you achieve better risk-adjusted returns.


                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to='/mutual-funds'><li>mutual-funds →</li></Link>
                            <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                            <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                            <Link to='/nri-corner'><li>NRI Corner →</li></Link>
                            <Link to='/family-offices'><li>Family Offices →</li></Link>
                            <Link to='/insurance'><li>Insurance →</li></Link>
                            <Link to='/loan-syndication'><li>Loan Syndication→</li></Link>
                            <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                            <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                            <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default PMS


